import {Logo} from 'components/system/logo';
import {useIsMobile} from 'hooks/is_mobile';
import Link from 'next/link';
import React from 'react';
import {classNames} from 'utils';
import styles from './auth_layout.module.css';

export const AuthLayout = ({cta, children}: Props) => {
  const isMobile = useIsMobile();
  return (
    <div className={classNames([styles.container, cta && styles.fullHeight])}>
      <div className={styles.content}>
        <Link prefetch={false} href='/'>
          <a>
            <Logo />
          </a>
        </Link>
        <div className={styles.children}>{children}</div>
      </div>
      {!isMobile && cta}
    </div>
  );
};

type Props = {
  cta?: JSX.Element;
  children?: React.ReactNode;
};
